module.exports = __webpack_public_path__ + "img/Pattern03.3cfe925d.png";